const TRANSLATION_ENDPOINT = '/business-api/message-translate.php';

export function nlcTranslationScopeKey(conversationId, language, token) {
  return JSON.stringify([String(conversationId || ''), String(language || ''), String(token || '')]);
}

export function nlcIndicatorState(payload = {}) {
  const nlc = payload.nlc || {};
  if (!nlc.enabled) {
    return 'off';
  }
  if (!payload.service_enabled || !nlc.has_access) {
    return 'exhausted';
  }
  if (['professional', 'enterprise'].includes(nlc.plan)) {
    return 'active';
  }

  const remainingMinutes = Number(nlc.remaining_minutes);
  if (Number.isFinite(remainingMinutes)) {
    if (remainingMinutes <= 0) {
      return 'exhausted';
    }
    if (remainingMinutes <= 60) {
      return 'warning';
    }
  }
  return 'active';
}

export class MessageTranslationError extends Error {
  constructor(message, code = '') {
    super(message);
    this.name = 'MessageTranslationError';
    this.code = code;
  }
}

async function nlcRequest(body, signal) {
  const response = await fetch(TRANSLATION_ENDPOINT, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body),
    signal
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.ok === false) {
    throw new MessageTranslationError(
      payload.message || `NLC 请求失败 (${response.status})`,
      payload.errorCode || ''
    );
  }
  return payload;
}

export async function getNlcStatus({ token, signal } = {}) {
  return nlcRequest({ action: 'status', token }, signal);
}

export async function setNlcEnabled({ token, enabled, signal } = {}) {
  return nlcRequest({ action: 'preference', token, enabled: Boolean(enabled) }, signal);
}

export async function translateMessage({ token, targetLanguage, message, context = [], signal }) {
  const payload = await nlcRequest({ action: 'translate', token, target_language: targetLanguage, message, context }, signal);
  return payload.translation || {};
}
